(() => {
  'use strict';
  if (window.__abmiumMerchantWidgetScheduled) return;
  window.__abmiumMerchantWidgetScheduled = true;
  const events = ['pointerdown', 'touchstart', 'keydown', 'scroll'];
  let scheduled = false;
  let fallback;
  const start = () => {
    if (!window.merchantwidget?.start) return;
    window.merchantwidget.start({
      merchant_id: '5805192750', position: 'LEFT_BOTTOM',
      sideMargin: 36, bottomMargin: 36, mobileSideMargin: 16, mobileBottomMargin: 46
    });
    const title = () => {
      const frame = document.getElementById('merchantwidgetiframe');
      if (frame) frame.title = 'Google store quality badge';
    };
    title();
    const observer = new MutationObserver(title);
    observer.observe(document.body, {childList: true, subtree: true});
    window.setTimeout(() => observer.disconnect(), 10000);
  };
  const load = () => {
    const src = 'https://www.gstatic.com/shopping/merchant/merchantwidget.js';
    const existing = Array.from(document.scripts).find(script => script.src === src);
    if (existing) {
      if (window.merchantwidget?.start) start();
      else existing.addEventListener('load', start, {once: true});
      return;
    }
    const script = document.createElement('script');
    script.id = 'merchantWidgetScript';
    script.src = src;
    script.async = true;
    script.fetchPriority = 'low';
    script.addEventListener('load', start, {once: true});
    document.head.appendChild(script);
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    window.clearTimeout(fallback);
    events.forEach(event => window.removeEventListener(event, schedule));
    window.setTimeout(load, 3000);
  };
  const ready = () => {
    events.forEach(event => window.addEventListener(event, schedule, {passive: true}));
    fallback = window.setTimeout(schedule, 45000);
  };
  if (document.readyState === 'complete') ready();
  else window.addEventListener('load', ready, {once: true});
})();
